// extracted by mini-css-extract-plugin
export default {"pageBody":"App_pageBody__Fg60q","contentContainer":"App_contentContainer__3gsZa"};